import client from '/src/services/client.js';
// Endpoint api block children
export default {
    createBlockChild : (bot_id, block_id, child) => client.post(`bot/${bot_id}/block/${block_id}/child`, child),
    updateBlockChild : (bot_id, block_id, id, child) => client.put(`bot/${bot_id}/block/${block_id}/child/${id}`, child),
    updateBlockChildren : (bot_id, block_id, children) => client.put(`bot/${bot_id}/block/${block_id}/children`, children),
    deleteBlockChild : (bot_id, block_id, id) => client.delete(`bot/${bot_id}/block/${block_id}/child/${id}`),
}